import { pageKeyFor } from '../shared/helpers.js';

const getters = {
    // Layout getters
    getDashboardLayout: (state) => (pageType) => {
        const raw = state.dashboardLayouts[pageType];
        if(!raw){
            return { cols:1, rows:12, gap:16 };
        }
        // Numeric structure only ("1","2","3").
        let cols = 1;
        if(raw.structure && typeof raw.structure === 'string'){
            const s = raw.structure.trim();
            if(/^\d+$/.test(s)){
                const n = Number(s);
                if(n>=1) cols = n; // clamp later in UI if needed
            }
        } else if(Array.isArray(raw.rows) && raw.rows[0]?.columns){
            cols = raw.rows[0].columns.length || 1;
        }
        // Approximate row count as number of layout row entries or fallback
        let rows = Array.isArray(raw.rows) ? raw.rows.length : 12;
        return { ...raw, cols, rows, gap: raw.gap || 16 };
    },
    
    // Widget getters
    getPageWidgets: (state) => (pageType) => {
        const key = pageKeyFor(pageType);
        return state.pageWidgets[key] || [];
    },
    
    // Removed granular widget getters (CRUD kaldırıldı); bileşenler doğrudan getPageWidgets kullanabilir
    
    // Available widgets getters
    getAvailableWidgets: (state) => (pageType) => {
        const key = pageKeyFor(pageType);
        return state.availableWidgets[key] || [];
    },
    
    getAvailableWidgetByType: (state) => (pageType, widgetType) => {
        const key = pageKeyFor(pageType);
        const widgets = state.availableWidgets[key] || [];
        return widgets.find(widget => widget.type === widgetType);
    },
    
    // Loading getters
    isLoading: (state) => (type) => {
        return state.loading[type] || false;
    },
    
    // Error getters
    getError: (state) => (type) => {
        return state.errors?.[type] || null;
    },
    
    hasErrors: (state) => {
        return Object.values(state.errors).some(error => error !== null);
    },

    // Panel getters
    getPanels: (state) => (pageType) => {
        const key = pageKeyFor(pageType);
        return (state.panels?.[key] || []);
    },
    getActivePanel: (state) => (pageType) => {
        const key = pageKeyFor(pageType);
        return state.activePanel?.[key];
    },
    getActivePanelObject: (state, getters) => (pageType) => {
        const id = getters.getActivePanel(pageType);
        return (getters.getPanels(pageType) || []).find(p=>p.id===id) || null;
    },
    getPanelDetail: (state) => (panelId) => state.panelDetails[panelId] || null,

    getQueues: (state) => state.queues || [],
    getAccounts: (state) => state.accounts || [],
};

export default getters;
